import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpEvent } from '@angular/common/http';
import { CreatePodcastDto, PodcastDto, UpdatePodcastDto } from '@bemum/api-interfaces';

@Injectable({ providedIn: 'root' })
export class PodcastService {
  constructor(private http: HttpClient) {}

  upload(formData: FormData, root: string): Observable<HttpEvent<any>> {
    const req = new HttpRequest('POST', `${environment.api_url}/podcast/${root}`, formData, {
      reportProgress: true,
      withCredentials: false,
    });
    return this.http.request<HttpEvent<any>>(req);
  }

  getList(): Observable<PodcastDto[]> {
    return this.http.get<PodcastDto[]>(`${environment.api_url}/podcast`);
  }

  get(id: string): Observable<PodcastDto> {
    return this.http.get<PodcastDto>(`${environment.api_url}/podcast/${id}`);
  }

  post(data: CreatePodcastDto): Observable<CreatePodcastDto> {
    return this.http.post<CreatePodcastDto>(`${environment.api_url}/podcast`, data);
  }

  update(id:string, data:UpdatePodcastDto):Observable<PodcastDto> {
    return this.http.patch<PodcastDto>(`${environment.api_url}/podcast/${id}`, data)
  }

  delete(id: string) {
    return this.http.delete(`${environment.api_url}/podcast/${id}`);
  }

}
